import { RouteObject } from "react-router-dom";
import { DataManagementRoutesConfig } from "./config";
import DataManagementPage from "../routes/DataManagementPage";

export const DataManagementRoutes: RouteObject = {
  path: DataManagementRoutesConfig.dataManagementPage,
  index: true,
  element: <DataManagementPage />,
};
